import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, mobileOrderButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/nGWf3U7WJ3dLnb6Nys0h/locations/abYSs8K1AMonjLmY8rw0`}
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={mobileOrderButton}
                  w="100%"
                  maxWidth="310px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/nGWf3U7WJ3dLnb6Nys0h/locations/abYSs8K1AMonjLmY8rw0`}
              target="_blank"
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="280px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
